import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const NoteToBuyerCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Note to buyer", cell: (row) => row.noteToBuyer || "" };
